<template>
	<div class="ttshop_singheader">
		<div class="ttshop_singheadercon w clearfloat">
			<div class="ttshop_singleft clearfloat d-flex align-items-center">
				<div class="ttshop_singimg">
					<router-link to="/" :title='common_info.store.name'><img class="img-default" :src="common_info.store.logo" :alt="common_info.store.name"></router-link>
				</div>
				<div class="ttshop_singtext">
					<h4 v-text="headertext"></h4>
				</div>
			</div>
			<div class="ttshop_singright clearfloat">
				<p class="ttshop_hotline" v-if="common_info.help.copyright.phone">服务热线：<span v-text="common_info.help.copyright.phone"></span></p>
				<div class="ttshop_singmobile" v-if="false">
					<div class="ttshop_singbut clearfloat">
						<i><img class="img-default" src="../../../assets/images/ttshop_mobile.png" alt=""></i>
						<span>APP下载</span>
						<strong><img class="img-default" src="../../../assets/images/ttshop_orderxl.png" alt=""></strong>
						<div class="ttshop_qrcode">
							<img class="img-default" src="../../../assets/images/app.jpg" alt="">
						</div>
					</div>
				</div>
				<div class="ttshop_singmobile" v-if="false">
					<div class="ttshop_singbut clearfloat">
						<i><img class="img-default" src="../../../assets/images/ttshop_wechat.png" alt=""></i>
						<span>小程序</span>
						<strong><img class="img-default" src="../../../assets/images/ttshop_orderxl.png" alt=""></strong>
						<div class="ttshop_qrcode">
							<img class="img-default" src="../../../assets/images/app.jpg" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["headertext"],
		data() {
			return {
				common_info: {
					help: {
						copyright: {},
					},
					store: {}
				},
			};
		},
		created() {
			this.common.getCommonInfo(this);
		},
		methods: {
			
		}
	};
</script>

<style lang="scss" scoped>
	.ttshop_singheader {
		width: 100%;
		height: 88px;
		background: #fff;

		.ttshop_singheadercon {
			height: 88px;
			background: #fff;

			.ttshop_singleft {
				float: left;
				height: 88px;

				.ttshop_singimg {
					float: left;
					min-width: 136px;
					min-height: 40px;
					margin-right: 24px;
					cursor: pointer;

					a {
						display: block;
						width: 187px;
						height: 55px;
						img {
							width: auto;
							height: auto;
							object-fit: fill;
							display: block;
							margin: 0 auto;
							max-width: 100%;
							max-height: 100%;
						}
					}
				}

				.ttshop_singtext {
					float: left;
					height: 40px;
					border-left: 1px solid #ebebeb;
					padding-left: 13px;
					box-sizing: border-box;
					line-height: 40px;

					h4 {
						font-size: 16px;
						color: #999;
						font-weight: 600;
					}
				}
			}

			.ttshop_singright {
				float: right;
				height: 88px;

				.ttshop_hotline {
					float: left;
					color: #ff0e25;
					font-size: 14px;
					font-weight: 500;
					line-height: 88px;
					margin-right: 20px;

					span {
						color: #ff0e25;
						font-size: 14px;
					}
				}

				.ttshop_singmobile {
					float: left;
					margin-right: 20px;

					&:last-child {
						margin-right: 0;
					}

					.ttshop_singbut {
						padding-top: 33px;
						padding-bottom: 10px;
						box-sizing: border-box;
						cursor: pointer;
						position: relative;

						i {
							float: left;
							width: 14px;
							height: 14px;
							margin-right: 4px;
							margin-top: 2px;

							img {
								display: block;
							}
						}

						span {
							float: left;
							font-size: 14px;
							color: #333;
							margin-right: 4px;
						}

						strong {
							float: left;
							width: 12px;
							height: 12px;
							margin-top: 5px;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;

							img {
								display: block;
							}
						}

						.ttshop_qrcode {
							position: absolute;
							top: 60px;
							left: 50%;
							margin-left: -60px;
							width: 120px;
							height: 120px;
							padding: 5px;
							box-sizing: border-box;
							background: #fff;
							border-radius: 4px;
							box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
							display: none;
							z-index: 10;

							&::before {
								content: "";
								width: 0px;
								height: 0px;
								border-width: 8px;
								border-style: solid;
								border-color: transparent transparent #fff transparent;
								position: absolute;
								top: -16px;
								left: 50%;
								margin-left: -8px;
							}

							img {
								display: block;
								width: 110px;
								height: 110px;
							}
						}

						&:hover strong {
							transform: rotate(-180deg);
							-ms-transform: rotate(-180deg);
							-moz-transform: rotate(-180deg);
							-webkit-transform: rotate(-180deg);
							-o-transform: rotate(-180deg);
						}

						&:hover .ttshop_qrcode {
							display: block;
						}
					}
				}
			}
		}
	}
</style>
